// Porta leve para `src/app` e `src/routes` (JS inicial): manifestos, schemas de busca, catálogo e carregadores.
export { CHATBOT_PATH, CHATBOT_REPORT_PATH, chatbotDetailScreen, chatbotListScreen, chatbotReportScreen } from './chatbot.screen';
export { chatbotDetailSearch, chatbotListSearch } from './chatbot.search';
export { loadChatbotMessages } from './chatbot.catalog';

/** As telas das rotas (`ChatbotListRouteScreen`, `ChatbotReportRouteScreen`, `ChatbotDetailRouteScreen`), por `lazyScreen`. */
export const loadChatbotListScreen = () => import('./chatbot-list.page');
export const loadChatbotReportScreen = () => import('./chatbot-report.page');
export const loadChatbotDetailScreen = () => import('./chatbot-detail.page');

/** Os guias das três telas para o Luy (U46), sob demanda. */
export const loadChatbotGuides = () => import('./chatbot.guide');
